export default {
  name: 'Aimage',
  props: {
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const list = this.options || this.option || this.config || this.items || this.data || [];
    const link = attrs.src || attrs.url || attrs.link || attrs.icon || attrs.image;
    return (
      <el-image lazy key={link} src={link} preview-src-list={list} {...{ attrs }}>
        <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div>
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline" />
        </div>
        {this.$slots.default}
      </el-image>
    );
  }
}